/* global L, bootstrap */
/* exported ShowOnMap */

window.mapDefaults = {
	maxZoom: 18,
	minZoom: 5,
	attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
};

window.mapUrl = 'https://maptiles-de.jjk.de/tile/{z}/{x}/{y}.png';

L.Icon.Default.imagePath = '/fileadmin/vendor/leaflet/dist/images/';

class ShowOnMap {
	constructor(options = {}) {
		this.points = [];
		this.map = undefined;
		this.mapDomId = options.mapDomId || 'map';
		this.init();
	}

	init() {
		const mapElem = document.getElementById(this.mapDomId);
		if (!mapElem) {
			throw new Error('Map Element existiert nicht!');
		}
		/** @type {HTMLElement[]} */
		const elemente =
			'mapLat' in mapElem.dataset
				? [mapElem] // Spezielfall: wenn der Map direkte Koordinaten gegeben wurden (u.A. bei Veranstaltungen), gelten nur diese und nicht bspw. die des BCard-ListItems des Veranstalters
				: Array.from(document.querySelectorAll('[data-map-lat]'));
		for (const elem of elemente) {
			const lat = parseFloat(elem.dataset.mapLat);
			const lon = parseFloat(elem.dataset.mapLon);
			const url = elem.dataset.mapUrl || (elem.tagName.toLowerCase() === 'a' ? elem.href : '');
			if (!isNaN(lat) && !isNaN(lon)) {
				$('#map').filter(':hidden').show();
				this._execute(lat, lon, elem.dataset.mapName, url);
			}
		}
		this._fitBounds();
		mapElem.querySelectorAll('.leaflet-marker-pane').forEach(elem => {
			elem.querySelectorAll('[title]').forEach(elemMitTitel => {
				new bootstrap.Tooltip(elemMitTitel);
			});
		});
	}

	_fitBounds() {
		if (this.map && 'fitBounds' in this.map) {
			this.map.fitBounds(this.points, { padding: [20, 20] });
		}
	}

	_execute(lat, lon, title, url) {
		if (this.points.length === 0) {
			this.map = L.map(this.mapDomId, { scrollWheelZoom: false });
			// Map (teilweise) vor Screenreadern verstecken, da unwichtig
			this.map.attributionControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
			this.map.attributionControl.getContainer().ariaDisabled = true;
			this.map.getContainer().ariaDisabled = true;
			this.map.getContainer().tabIndex = -1;
			L.tileLayer(window.mapUrl, window.mapDefaults).addTo(this.map);
		}
		this.points.push([lat, lon]);
		const marker = L.marker([lat, lon], { title: title, clickable: !!url, keyboard: !!url, alt: title, interactive: !!url }).addTo(this.map);
		if (url) {
			marker.on('click', () => {
				window.location = url;
			});
			marker.on('keydown', evt => {
				if (evt.originalEvent.key === 'Enter') {
					window.location = url;
				}
			});
		}
	}

	clear() {
		this.points = [];
		if (this.map) {
			this.map.remove();
			this.map = undefined;
		}
		$('#map').filter(':visible').hide();
	}
}
